import { defineStore } from "pinia";
import http from "@/http";
import {
  LIST_ENTRADA,
  ADD_ENTRADA,
  UPDATE_ENTRADA,
  DEL_ENTRADA,
  LIST_ITEM_ENTRADA,
  ADD_ITEM_ENTRADA,
  UPDATE_ITEM_ENTRADA,
  DEL_ITEM_ENTRADA,
  LIST_SAIDA,
  ADD_SAIDA,
  UPDATE_SAIDA,
  DEL_SAIDA,
  LIST_ITEM_SAIDA,
  ADD_ITEM_SAIDA,
  UPDATE_ITEM_SAIDA,
  DEL_ITEM_SAIDA,
} from "@/http/url";

export const useEntradaSaidaStore = defineStore("EntradaSaidaStore", {
  state: () => {
    return {
      entradas: [],
      entradaItens: [],
      saidas: [],
      saidaItens: [],
      loaded: false,
    };
  },

  persist: { storage: sessionStorage },

  //Os actions não precisam das mutations, acessam diretamente o state
  actions: {
    //ENTRADAS E ITENS
    LISTAR_ENTRADAS() {
      return new Promise((resolve, reject) => {
        http
          .get(LIST_ENTRADA)
          .then((response) => {
            this.entradas = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_ENTRADA(entrada) {
      return http
        .post(ADD_ENTRADA, entrada)
        .then((response) => this.entradas.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_ENTRADA(entrada) {
      return http
        .put(`${UPDATE_ENTRADA + entrada.id}`, entrada)
        .then((response) => {
          const index = this.entradas.findIndex((objeto) => objeto.id === response.data.id);
          this.entradas[index] = response.data;
        })
        .catch((erro) => {
          console.log(erro);
        });
    },

    REMOVER_ENTRADA(id) {
      return http.delete(`${DEL_ENTRADA + id}`).then(() => (this.entradas = this.entradas.filter((object) => object.id != id)));
    },

    LISTAR_ENTRADA_ITENS(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${LIST_ITEM_ENTRADA + id}`)
          .then((response) => {
            this.entradaItens = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_ENTRADA_ITEM(item) {
      return http.post(ADD_ITEM_ENTRADA, item).catch((erro) => {
        console.log(erro);
      });
    },

    ALTERAR_ENTRADA_ITEM(item) {
      return http.put(`${UPDATE_ITEM_ENTRADA + item.id}`, item);
    },

    REMOVER_ENTRADA_ITEM(id) {
      return http
        .delete(`${DEL_ITEM_ENTRADA + id}`)
        .then(() => (this.entradaItens = this.entradaItens.filter((item) => item.id != id)));
    },

    //SAIDAS E ITENS
    LISTAR_SAIDAS() {
      return new Promise((resolve, reject) => {
        http
          .get(LIST_SAIDA)
          .then((response) => {
            this.saidas = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_SAIDA(saida) {
      return http
        .post(ADD_SAIDA, saida)
        .then((response) => this.saidas.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_SAIDA(saida) {
      return http
        .put(`${UPDATE_SAIDA + saida.id}`, saida)
        .then((response) => {
          const index = this.saidas.findIndex((objeto) => objeto.id === response.data.id);
          this.saidas[index] = response.data;
        })
        .catch((erro) => {
          console.log(erro);
        });
    },

    REMOVER_SAIDA(id) {
      return http.delete(`${DEL_SAIDA + id}`).then(() => (this.saidas = this.saidas.filter((object) => object.id != id)));
    },

    LISTAR_SAIDA_ITENS(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${LIST_ITEM_SAIDA + id}`)
          .then((response) => {
            this.saidaItens = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_SAIDA_ITEM(item) {
      return http.post(ADD_ITEM_SAIDA, item).catch((erro) => {
        console.log(erro);
      });
    },

    ALTERAR_SAIDA_ITEM(item) {
      return http.put(`${UPDATE_ITEM_SAIDA + item.id}`, item);
    },

    REMOVER_SAIDA_ITEM(id) {
      return http
        .delete(`${DEL_ITEM_SAIDA + id}`)
        .then(() => (this.saidaItens = this.saidaItens.filter((item) => item.id != id)));
    },
  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    //ENTRADAS
    getEntradas() {
      return this.entradas;
    },

    getEntradaById: (state) => {
      return (id) => {
        return state.entradas.filter((object) => !id || object.id == id);
      };
    },

    getEntradaItens(state) {
      return state.entradaItens;
    },

    getFilterEntradas: (state) => {
      return (filtro) => {
        let filtrada = state.entradas;
        filtrada = filtrada.filter(
          (obj) =>
            !filtro ||
            (obj.descricao.includes(filtro.descricao) &&
              obj.cliente.includes(filtro.cliente) &&
              obj.recebeu.includes(filtro.recebeu))
        );

        return filtrada;
      };
    },

    //SAIDAS
    getSaidas() {
      return this.saidas;
    },

    getSaidaById: (state) => {
      return (id) => {
        return state.saidas.filter((object) => !id || object.id == id);
      };
    },

    getSaidaItens(state) {
      return state.saidaItens;
    },

    getFilterSaidas: (state) => {
      return (filtro) => {
        let filtrada = state.saidas;
        filtrada = filtrada.filter(
          (obj) =>
            !filtro ||
            (obj.descricao.includes(filtro.descricao) &&
              obj.cliente.includes(filtro.cliente) &&
              obj.recebeu.includes(filtro.recebeu))
        );

        return filtrada;
      };
    },

    getEntradaSaidaLoad(state) {
      return state.loaded;
    },
  },
});
